import { Button } from 'components'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import * as Styles from './Navigation.module.css'
import Hamburger from './components/Hamburger'

const Navigation = ({
  showNavigation,
  navState,
  navHeight,
  smallWindow,
  handleClose,
  handleToggleNavigation,
}) => {
  const data = useStaticQuery(query)

  // Todo: accessibility - aria
  return showNavigation ? (
    <div className={Styles.navWrapper}>
      <button
        className={`${Styles.mobileToggle} ${
          navState && Styles.mobileToggleActive
        }`}
        onClick={handleToggleNavigation}
      >
        <div className="sr-only">Navigation</div>
        <Hamburger navState={navState} />
      </button>

      <nav aria-labelledby="Main Navigation" className={`${Styles.navigation}`}>
        <ul
          className={
            navState && smallWindow ? Styles.activeNav : Styles.navItems
          }
          style={{ top: navHeight }}
        >
          {(data.wpMenu.menuItems.nodes || []).map(({ id, label, path }) => {
            return (
              <li key={id}>
                <Button
                  className={navState && smallWindow ? 'text-xl' : ''}
                  as="span"
                  type="text"
                  to={path}
                  onClick={handleClose}
                >
                  {label}
                </Button>
              </li>
            )
          })}
        </ul>
      </nav>
    </div>
  ) : (
    <></>
  )
}

export const query = graphql`
  {
    wpMenu(name: { eq: "header" }) {
      menuItems {
        nodes {
          id
          label
          parentId
          path
          childItems {
            nodes {
              id
              label
              path
            }
          }
        }
      }
    }
  }
`

Navigation.propTypes = {
  showNavigation: PropTypes.bool,
  navState: PropTypes.bool,
  parent: PropTypes.object,
  handleToggleNavigation: PropTypes.func,
}

export default Navigation
